<template>
  <field-autocomplete
    ref="autocomplete"
    v-bind="$attrs"
    v-model="iValue"
    :field="{}"
    :filter="customFilter"
    :item-value="itemValue || getUserProfileId"
    :remote="remote"
    :return-object="returnObject"
    item-text="email"
    class="field"
    cache-items
    hide-selected
    custom-selection
    custom-item
    v-on="$listeners"
  >
    <template #selection="data">
      <div class="v-select__selection v-select__selection--comma d-flex align-center">
        <avatar
          :size="24"
          :initials="initial(data.item)"
          :url="data.item.avatar && data.item.avatar.urlCached"
        />
        <span class="text--truncate ml-1">{{ getName(data.item) }}</span>
      </div>
    </template>
    <template #item="data">
      <avatar
        :size="30"
        :initials="initial(data.item)"
        :url="data.item.avatar && data.item.avatar.urlCached"
        class="mr-2"
      />
      <v-list-item-content>
        <v-list-item-title v-html="getName(data.item)" />
        <v-list-item-title v-html="getCompanyName(data.item)" />
        <v-list-item-subtitle v-html="data.item.email" />
      </v-list-item-content>
    </template>
  </field-autocomplete>
</template>

<script>
import Autocomplete from '@/services/Autocomplete'
import FieldAutocomplete from '../FieldAutocomplete'
import initials from '@/services/initials'

export default {
  name: 'FieldEntityUserProfileApplicant',
  components: {
    FieldAutocomplete
  },
  props: {
    companyId: {
      type: Number,
      default: null
    },
    excludeIds: {
      type: Array,
      default: () => ([])
    },
    itemValue: {
      type: String,
      default: null
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, Object, Number],
      default: null
    }
  },
  computed: {
    iValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('change', val)
      }
    },
    remote () {
      const userProfileId = this.returnObject
        ? this.iValue?.profile?.userProfileId
        : this.iValue

      return {
        url: '/user-profiles/search?profileType=applicant',
        urlFind: '/user-profiles/search?profileType=applicant',
        urlFindKey: 'uid',
        urlFindParams: {
          uid: userProfileId ?? null,
        },
        method: 'GET',
        params: {
          companyId: this.companyId,
          excludeIds: this.excludeIds,
          searchParam: 'search'
        }
      }
    }
  },
  created () {
    this.$off('change')
  },
  methods: {
    customFilter: Autocomplete.userEntitycustomFilter,
    getUserProfileId (item) {
      return item.uid ?? null
    },
    getCompanyName (item) {
      return item?.companyName === '-' ? null : item?.companyName ?? null
    },
    getName (item) {
      if (!item.firstName && !item.lastName) {
        return this.$t('common.undefined')
      }
      return `${item.firstName || ''} ${item.lastName || ''}`
    },
    initial (item) {
      return initials(item.firstName, item.lastName, item.displayName, item.email)
    }
  }
}
</script>
